import React from 'react';
import { Layout, Space } from 'antd';
import { PoweroffOutlined } from '@ant-design/icons';

const { Header } = Layout;

interface AppHeaderProps {
  onLogout: () => void;
}

export const AppHeader: React.FC<AppHeaderProps> = ({ onLogout }) => {
  return (
    <Header style={{ backgroundColor: '#00BCD4', display: 'flex', justifyContent: 'end', alignItems: 'center', padding: '0 20px' }}>
      <span style={{ cursor: 'pointer', fontSize: '24px' }} onClick={onLogout}>
        <PoweroffOutlined />
      </span>
    </Header>
  );
}; 